export default {"src":"/_next/static/media/error_page_icon.324ab5b7.svg","height":57,"width":66};